import { NavigationItem } from '../models/permissions/permission.interfaces';
import { UserRole } from '../models/permissions/user-role.enum';

export const NAVIGATION_CONFIG: NavigationItem[] = [
  // Doctor and Psycho items (same permissions)
  {
    path: '/agenda',
    label: 'Agenda',
    icon: 'lucideCalendar',
    permission: { roles: [UserRole.DOCTOR, UserRole.PSYCHO] }
  },
  {
    path: '/my-patients',
    label: 'I miei pazienti',
    icon: 'lucideUsers',
    permission: { roles: [UserRole.DOCTOR, UserRole.PSYCHO] }
  },
  {
    path: '/my-appointments',
    label: 'I miei appuntamenti',
    icon: 'lucideSpeech',
    permission: { roles: [UserRole.DOCTOR, UserRole.PSYCHO] }
  },

  // Clinic items
  {
    path: '/agenda',
    label: 'Agenda',
    icon: 'lucideCalendar',
    permission: { roles: [UserRole.CLINIC] }
  },
  {
    path: '/pathways-management',
    label: 'Gestione percorsi',
    icon: 'lucideFolderCog',
    permission: { roles: [UserRole.CLINIC] }
  },
  {
    path: '/bookings',
    label: 'Prenotazioni',
    icon: 'lucideFileText',
    permission: { roles: [UserRole.CLINIC] }
  },

  // Patient items
  {
    path: '/home',
    label: 'Home',
    icon: 'lucideHouse',
    permission: { roles: [UserRole.PATIENT] }
  },
  {
    path: '/my-pathway',
    label: 'Il mio percorso',
    icon: 'lucideRoute',
    permission: { roles: [UserRole.PATIENT] }
  },
  {
    path: '/my-prescriptions',
    label: 'Le mie prescrizioni',
    icon: 'lucideFileText',
    permission: { roles: [UserRole.PATIENT] }
  },
  {
    path: '/my-consultations',
    label: 'I miei consulti',
    icon: 'lucideSpeech',
    permission: { roles: [UserRole.PATIENT] }
  },
  {
    path: '/my-doctor-team',
    label: 'Il team medico',
    icon: 'lucideStethoscope',
    permission: { roles: [UserRole.PATIENT] }
  },
  {
    path: '/my-documents',
    label: 'I miei documenti',
    icon: 'lucideFolder',
    permission: { roles: [UserRole.PATIENT] }
  },

  // Common items
  {
    path: '/patients-documents',
    label: 'Documenti pazienti',
    icon: 'lucideFolder',
    permission: { roles: [UserRole.DOCTOR, UserRole.CLINIC, UserRole.PSYCHO] }
  },
  {
    path: '/account',
    label: 'Account',
    icon: 'lucideUserRound',
    permission: { roles: [UserRole.PATIENT, UserRole.DOCTOR, UserRole.CLINIC, UserRole.PSYCHO] }
  },
];